<template>
	<div class="custom-select" :tabindex="tabindex" @blur="open = false">
		<div
			class="selected"
			:class="{
				open: open,
				placeholder: placeholder === parseOption(selectedOption)
			}"
			@click="open = !open"
		>
			{{ parseOption(selectedOption) }}
		</div>
		<div class="items" :class="{ selectHide: !open }">
			<div
				v-for="(option, i) of options"
				:key="i"
				@click="
					selected = option
					open = false
					$emit('input', option)
				"
			>
				{{ parseOption(option) }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'selector',
	props: {
		options: {
			type: Array,
			required: true
		},
		default: {
			type: String,
			required: false,
			default: null
		},
		tabindex: {
			type: Number,
			required: false,
			default: 0
		},
		label: {
			type: String,
			default: 'label'
		},
		placeholder: {
			type: String,
			default: '-'
		}
	},
	data() {
		return {
			open: false,
			selectedOption: null
		}
	},
	computed: {
		selected: {
			get() {
				if (this.default) return this.default
				if (this.options.length > 0) {
					return this.parseOption(this.options[0])
				}
				return null
			},
			set(newValue) {
				if (newValue.id === -1) {
					this.selectedOption = this.placeholder
				} else {
					this.selectedOption = newValue
				}
			}
		}
	},
	methods: {
		parseOption(option) {
			if (!option) return

			if (typeof option == 'object') {
				return option[this.label]
			}
			return option
		}
	},
	mounted() {
		this.$emit('input', this.selected)
		if (this.default) {
			this.selectedOption = this.default
		}
		this.selectedOption = this.placeholder
	}
}
</script>

<style scoped lang="scss">
.custom-select {
	position: relative;
	width: 100%;
	text-align: left;
	outline: none;
	height: 47px;
	line-height: 47px;
	margin-top: 10px;
	.selected {
		border-bottom: 1px solid $dark-grey;
		color: $charcoal;
		padding-left: 1em;
		cursor: pointer;
		user-select: none;
		&.open {
			border-bottom: 1px solid $navy;
			&:after {
				transform: rotate(180deg);
			}
		}
		&:after {
			position: absolute;
			content: '';
			top: 20px;
			right: 1em;
			background-image: url('../assets/downCarrot.svg');
			width: 25px;
			height: 15px;
			background-size: contain;
			background-repeat: no-repeat;
		}
	}
	.placeholder {
		color: $dark-grey;
	}
	.items {
		color: $charcoal;
		border-radius: 0px 0px 6px 6px;
		overflow: hidden;
		position: absolute;
		background-color: $bone !important;
		box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
		max-height: 250px;
		overflow-y: scroll;
		left: 0;
		right: 0;
		z-index: 1;
		div {
			color: $charcoal;
			padding-left: 1em;
			cursor: pointer;
			user-select: none;
			&:hover {
				color: #fff;
				background-color: $navy;
			}
		}
	}
}
.selectHide {
	display: none;
}
</style>
